import React from "react"
import "./EmailVerification.css"
import { API } from "../../../api"

class EmailVerification extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false
    }
  }

  async resendVerificationEmail() {
    const { account } = this.props.customerData
    this.setState({ submitting: true })
    try {
      const url = `customers/${account}/verify_email`
      await API.post(
        url,
        JSON.stringify({
          email: this.props.email,
          mobile: this.props.verifyMobile,
          order_uuid: this.props.orderUuid
        })
      )
    } catch (err) {
      console.log(err.response)
    } finally {
      this.setState({ submitting: false })
    }
  }

  componentDidMount() {
    window.gtag("config", "AW-779168230")
    window.gtag("event", "conversion", {
      send_to: "AW-779168230/i2JwCKPiuJgBEObTxPMC"
    })
  }

  render() {
    const {
      businessName,
      email,
      // emailVerificationError,
      backHandler
    } = this.props
    return (
      <div className="EmailVerification">
        <div className="EmailVerification-container">
          <h1 className="business-name">{businessName}</h1>
          <h1>Please verify your email address</h1>
          <p>
            We sent a verification email to <span>{`[${email}]`}</span>. Verify
            your email address to secure your account and keep your Qarabao data
            safe.
          </p>
          <button
            className="black"
            onClick={() => {
              this.resendVerificationEmail()
            }}
          >
            {this.state.submitting
              ? "Resending..."
              : "Resend verification link"}
          </button>
          <button type="button" className="gray" onClick={backHandler}>
            Return to Log In
          </button>
        </div>
      </div>
    )
  }
}

export default EmailVerification
